module.exports = __webpack_public_path__ + "static/media/image17.09ebb311.png";